import React from "react";

type ResetFiltersButtonProps = {
    label: React.ReactNode;
    onReset: () => void;
};

const ResetFiltersButton: React.FC<ResetFiltersButtonProps> = ({ label, onReset }) => (
    <button
        type="button"
        className="touch-manipulation self-end text-sm text-neutral-950 underline underline-offset-2 hover:text-gray-500 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        onClick={onReset}
    >
        {label}
    </button>
);

export default ResetFiltersButton;
